/**
 * Mappa dei `funnel_events.event_name` → etichetta italiana umana per
 * dashboard admin / chiamate commerciali. Aggiungere qui ogni nuovo evento
 * tracciato dal frontend o dal backend.
 *
 * Per eventi con label dinamica (es. `drip_whatsapp_sent` con `template_tag`
 * nel payload), usa la funzione `formatEvent(eventName, payload)` invece di
 * leggere direttamente da EVENT_LABELS.
 */
export const EVENT_LABELS = {
  // --- Acquisizione lead ---
  lead_generated:                       { label: "Lead registrato",                              icon: "📝", group: "lead" },
  lead_completato:                      { label: "Password creata · Lead completato",            icon: "🔐", group: "lead" },
  l2_info_requested:                    { label: "Richiesta informazioni Lezione 2",             icon: "🔥", group: "lead" },
  contact_request_full_course:          { label: "Richiesta info Corso completo (HOT LEAD)",     icon: "🔥", group: "lead" },
  lead_recupero_password_inviato:       { label: "Link recupero password inviato (admin)",       icon: "📤", group: "lead" },
  lead_reset_password_inviato:          { label: "Link reset password inviato",                  icon: "📤", group: "lead" },

  // --- Popup & dialog ---
  popup_consultation_displayed:         { label: "Popup consulenza mostrato",                    icon: "👀", group: "engagement" },
  popup_consulenza_gratuita_submitted:  { label: "Consulenza gratuita richiesta",                icon: "🎁", group: "lead" },
  popup_consultation_submitted:         { label: "Consulenza a pagamento richiesta",             icon: "💰", group: "lead" },
  l2_info_cta_shown_80pct:              { label: "CTA \"Richiedi info L.2\" mostrata (80% L1)",  icon: "🎯", group: "engagement" },
  l2_info_request_dialog_opened:        { label: "Popup richiesta L.2 aperto",                   icon: "👀", group: "engagement" },
  l2_info_request_silent_fire:          { label: "Richiesta L.2 inviata (consenso già dato)",    icon: "⚡", group: "lead" },

  // --- Click CTA / pulsanti ---
  below_cta_l2_info_click:              { label: "Click bottone \"Richiedi info L.2\"",          icon: "🖱️", group: "engagement" },
  below_cta_upsell_click:               { label: "Click bottone upsell sotto video",             icon: "🖱️", group: "engagement" },
  bundle_5_9_sales_click:               { label: "Click bottone \"Sblocca L.5-9 (€147)\"",       icon: "🖱️", group: "engagement" },
  upsell_confirm_shown:                 { label: "Popup conferma upsell mostrato",               icon: "👀", group: "checkout" },
  upsell_confirm_pay_click:             { label: "Click \"Conferma e paga\" upsell",             icon: "🖱️", group: "checkout" },

  // --- Visione video Lezione 1 ---
  lesson_1_started:                     { label: "Lezione 1 avviata",                            icon: "▶️", group: "video" },
  lesson_1_completed:                   { label: "Lezione 1 completata",                         icon: "✅", group: "video" },
  lesson_1_ending_cta_shown:            { label: "CTA finale Lezione 1 mostrata",                icon: "🎯", group: "video" },
  tempo_pagina_3m50s_lezione_1:         { label: "3 min 50s sulla Lezione 1",                    icon: "⏱️", group: "engagement" },
  tempo_pagina_6m20s_lezione_1:         { label: "6 min 20s sulla Lezione 1",                    icon: "⏱️", group: "engagement" },
  tempo_pagina_50pct_lezione_1:         { label: "50% video Lezione 1",                          icon: "⏱️", group: "engagement" },
  tempo_pagina_80pct_lezione_1:         { label: "80% video Lezione 1 (HOT LEAD)",               icon: "🔥", group: "engagement" },

  // --- Visione video Lezione 2 ---
  lesson_2_started:                     { label: "Lezione 2 avviata",                            icon: "▶️", group: "video" },
  lesson_2_completed:                   { label: "Lezione 2 completata",                         icon: "✅", group: "video" },
  lesson_2_ending_cta_shown:            { label: "CTA finale Lezione 2 mostrata",                icon: "🎯", group: "video" },
  tempo_pagina_50pct_lezione_2:         { label: "50% video Lezione 2",                          icon: "⏱️", group: "engagement" },
  tempo_pagina_80pct_lezione_2:         { label: "80% video Lezione 2 (HOT LEAD)",               icon: "🔥", group: "engagement" },

  // --- Visione video Lezione 3 ---
  lesson_3_started:                     { label: "Lezione 3 avviata",                            icon: "▶️", group: "video" },
  lesson_3_completed:                   { label: "Lezione 3 completata",                         icon: "✅", group: "video" },
  lesson_3_ending_cta_shown:            { label: "CTA finale Lezione 3 mostrata",                icon: "🎯", group: "video" },
  tempo_pagina_50pct_lezione_3:         { label: "50% video Lezione 3",                          icon: "⏱️", group: "engagement" },
  tempo_pagina_80pct_lezione_3:         { label: "80% video Lezione 3 (HOT LEAD)",               icon: "🔥", group: "engagement" },

  // --- Visione video Lezioni 4-9 ---
  lesson_4_started:                     { label: "Lezione 4 avviata",                            icon: "▶️", group: "video" },
  lesson_4_completed:                   { label: "Lezione 4 completata",                         icon: "✅", group: "video" },
  lesson_5_started:                     { label: "Lezione 5 avviata",                            icon: "▶️", group: "video" },
  lesson_5_completed:                   { label: "Lezione 5 completata",                         icon: "✅", group: "video" },
  lesson_6_started:                     { label: "Lezione 6 avviata",                            icon: "▶️", group: "video" },
  lesson_6_completed:                   { label: "Lezione 6 completata",                         icon: "✅", group: "video" },
  lesson_7_started:                     { label: "Lezione 7 avviata",                            icon: "▶️", group: "video" },
  lesson_7_completed:                   { label: "Lezione 7 completata",                         icon: "✅", group: "video" },
  lesson_8_started:                     { label: "Lezione 8 avviata",                            icon: "▶️", group: "video" },
  lesson_8_completed:                   { label: "Lezione 8 completata",                         icon: "✅", group: "video" },
  lesson_9_started:                     { label: "Lezione 9 avviata",                            icon: "▶️", group: "video" },
  lesson_9_completed:                   { label: "Lezione 9 completata",                         icon: "✅", group: "video" },

  // --- Checkout & acquisti ---
  checkout_initiated:                   { label: "Checkout Lezione 2 avviato (€2)",              icon: "🛒", group: "checkout" },
  purchase_lesson_2_success:            { label: "Acquisto Lezione 2 (€2)",                      icon: "💰", group: "purchase" },
  purchase_lesson_3_success:            { label: "Acquisto Lezione 3 (€10)",                     icon: "💰", group: "purchase" },
  purchase_l3_success:                  { label: "Acquisto Lezione 3 (€10)",                     icon: "💰", group: "purchase" },
  purchase_full_course_success:         { label: "Acquisto Corso Completo (€197)",               icon: "💎", group: "purchase" },
  upsell_card_error:                    { label: "Pagamento rifiutato (carta KO)",               icon: "❌", group: "purchase" },
  payment_failed:                       { label: "Pagamento fallito",                            icon: "❌", group: "purchase" },
  admin_purchase_marker:                { label: "Acquisto segnalato manualmente (admin)",       icon: "💶", group: "purchase" },

  // --- Sblocchi via magic-link ---
  unlock_claimed_bundle_234:            { label: "Bundle L.2-3-4 sbloccato (gratis)",            icon: "🎁", group: "purchase" },
  unlock_claimed_full_course:           { label: "Corso completo sbloccato (gratis)",            icon: "🎁", group: "purchase" },

  // --- Azioni admin ---
  admin_auto_login_link_generated:      { label: "Magic link auto-login generato (admin)",       icon: "🔗", group: "system" },
  admin_unlock_link_generated:          { label: "Link sblocco generato (admin)",                icon: "🔗", group: "system" },
  admin_granted_full_access:            { label: "Accesso totale concesso manualmente (admin)",  icon: "🎁", group: "purchase" },
  admin_granted_bundle_234:             { label: "Bundle L.2-3-4 concesso manualmente (admin)",  icon: "🎁", group: "purchase" },

  // --- Drip / system ---
  drip_send:                            { label: "Email/SMS automatica inviata",                 icon: "📨", group: "system" },
  drip_whatsapp_sent:                   { label: "Messaggio WhatsApp inviato",                   icon: "💬", group: "system" },
};


// ─────────────────────────────────────────────────────────────────────────
// Mappa template_tag → descrizione umana per dipendere il label generico
// "Messaggio WhatsApp inviato" con un sotto-titolo specifico tipo
// "Messaggio per recupero password inviato (R1 · variante A · msg 3/4)".
// Tenere allineato con /app/backend/core/messages_templates.py.
// ─────────────────────────────────────────────────────────────────────────
const TAG_TO_HUMAN = {
  // Legacy (Phase 1) — ancora referenziati da scheduled_messages vecchi
  msg_lead_no_password_3min:  "Messaggio recupero password inviato (legacy +3min)",
  msg_lead_no_lesson1_5min:   "Reminder Lezione 1 inviato (legacy +5min)",
  msg_l2_info_request_1:      "Messaggio HOT richiesta L.2 inviato · 1/2",
  msg_l2_info_request_2:      "Messaggio HOT richiesta L.2 inviato · 2/2",
  // Singoli
  msg_l1_b:                   "Reminder Lezione 1 inviato (R3 · già toccato)",
  msg_l2_req_a:               "Messaggio HOT richiesta L.2 inviato (R10)",
};

/**
 * Genera un sotto-titolo umano per un template_tag della Phase 5.
 * Esempi:
 *   msg_pwd_a3  → "Messaggio recupero password inviato · R1 · variante A · msg 3/4"
 *   msg_l1_a_b2 → "Reminder Lezione 1 inviato · R2 · variante B · msg 2/4"
 */
function describeTemplateTag(tag) {
  if (!tag) return null;
  if (TAG_TO_HUMAN[tag]) return TAG_TO_HUMAN[tag];

  // Pattern matching dinamico
  let m;
  if ((m = /^msg_pwd_([abc])(\d)$/.exec(tag))) {
    return `Messaggio recupero password inviato · R1 · variante ${m[1].toUpperCase()} · msg ${m[2]}/4`;
  }
  if ((m = /^msg_l1_a_([ab])(\d)$/.exec(tag))) {
    return `Reminder Lezione 1 inviato · R2 · variante ${m[1].toUpperCase()} · msg ${m[2]}/4`;
  }
  if ((m = /^msg_fb_a_(\d)$/.exec(tag))) {
    return `Reminder feedback L.1 inviato · R4 · msg ${m[1]}/3`;
  }
  if ((m = /^msg_fb_b_(\d)$/.exec(tag))) {
    return `Reminder feedback L.1 inviato · R5 · msg ${m[1]}/2`;
  }
  if ((m = /^msg_fb_c(\d)$/.exec(tag))) {
    return `Domanda feedback L.1 inviata · R6 · msg ${m[1]}/2`;
  }
  if ((m = /^msg_l2_(\d)$/.exec(tag))) {
    return `Offerta bundle L.2-3-4 inviata · R7 · msg ${m[1]}/4`;
  }
  if ((m = /^msg_l2_fb_(\d)$/.exec(tag))) {
    return `Feedback + bundle L.2-3-4 inviato · R8 · msg ${m[1]}/2`;
  }
  if ((m = /^msg_l2_pwd_(\d)$/.exec(tag))) {
    return `Feedback + bundle L.2-3-4 inviato · R9 · msg ${m[1]}/2`;
  }
  if ((m = /^msg_l2_req_b(\d)$/.exec(tag))) {
    return `Messaggio HOT richiesta L.2 inviato · R11 · msg ${m[1]}/2`;
  }
  return `Messaggio "${tag}" inviato`;
}


export const EVENT_GROUP_LABEL = {
  lead: "Lead",
  engagement: "Engagement",
  video: "Video",
  checkout: "Checkout",
  purchase: "Acquisto",
  system: "Sistema",
};

export const EVENT_GROUP_COLOR = {
  lead: "#10b981",
  engagement: "#3b82f6",
  video: "#6366f1",
  checkout: "#f59e0b",
  purchase: "#d95e39",
  system: "#94a3b8",
};

export function eventLabel(eventName) {
  return EVENT_LABELS[eventName]?.label || eventName;
}

export function eventIcon(eventName) {
  return EVENT_LABELS[eventName]?.icon || "•";
}

export function eventGroup(eventName) {
  return EVENT_LABELS[eventName]?.group || "system";
}

export function eventDescriptor(eventName) {
  return EVENT_LABELS[eventName] || { label: eventName, icon: "•", group: "system" };
}

/**
 * Descrittore arricchito che usa il payload per generare label dinamici
 * (es. drip_whatsapp_sent → "Messaggio recupero password inviato · R1·A·3/4").
 * Restituisce { label, icon, group, sublabel? }.
 */
export function formatEvent(eventName, payload) {
  const base = eventDescriptor(eventName);
  if (eventName === "drip_whatsapp_sent" && payload?.template_tag) {
    const detail = describeTemplateTag(payload.template_tag);
    return { ...base, label: detail || base.label, sublabel: payload.template_tag };
  }
  return base;
}


/**
 * Eventi mostrati nel pannello "🔥 Avvisi recenti" della dashboard admin.
 * Quei tre momenti richiedono azione commerciale immediata:
 *   - lead_generated     → un nuovo lead è entrato nel funnel
 *   - l2_info_requested  → ha chiesto info per la L.2 (intenzione d'acquisto)
 *   - lesson_4_completed → ha finito tutte le 4 lezioni gratuite (massima
 *                           propensione al bundle 5-9)
 * Tutti gli altri eventi restano disponibili in `/admin/eventi` ma NON
 * appaiono nei "Hot events".
 */
export const HIGH_PRIORITY_EVENTS = new Set([
  "lead_generated",
  "l2_info_requested",
  "lesson_4_completed",
]);

export function isHighPriorityEvent(eventName) {
  return HIGH_PRIORITY_EVENTS.has(eventName);
}
